<ng-content></ng-content>
<div
  #cardHeader
  class="header">
  <ng-content select="[header]">{{ header }}</ng-content>
</div>
